import { useContext } from 'react';
import { BarrioContext } from '../BarrioContext';

const PdfHeader = () => {
    const { barrio } = useContext(BarrioContext);
    const administracionLogo = localStorage.getItem('administracionLogo') || 'expensas360.png';
    return (
        <div className="pdf-header">
            {/* Izquierda: datos del administrador */}
            <div className="pdf-header-left">
                <div>Nicolas Guillermo Zaputovich</div>
                <div>CUIT: 20-29152739-7</div>
                <div>Dirección: El Hornero 101, Lote 1, Pilar</div>
                <div>Cel.: 114-192-9008</div>
                <div>Legajo REPAC: 277142</div>
                <div>Matricula REPAC: 465</div>
            </div>

            {/* Centro: logo */}
            <div className="pdf-header-center">
                <img src={`assets/layout/images/administradoras/${administracionLogo}`} alt="Logo" style={{ maxWidth: '203px', maxHeight: '101px', objectFit: 'contain', marginTop: '-10px' }} />
                <div className="pdf-header-subtitle">Barrios &amp; Consorcios</div>
            </div>

            {/* Derecha: datos del barrio */}
            <div className="pdf-header-right">
                <div><strong>{barrio?.nombre || ''}</strong></div>
                <div>CUIT: {barrio?.cuit || ''}</div>
                <div>Dirección: {barrio?.direccion || ''}</div>
            </div>
        </div>
    );
};

export default PdfHeader;
